import React from 'react';
import { Box } from '@mui/material';
import { ContactInformation } from '../../../_shared/bolt_components/screens/ContactInformation/ContactInformation';

const AvailabilityPage: React.FC = () => {
  return (
    <>
      <Box maxWidth="480px" mx="auto" overflow={'hidden'} px={'0'} py={1}>
        <ContactInformation />
      </Box>
    </>
  );
};

export default AvailabilityPage;
